import useSWR from 'swr';

/**
 API 说明汇总

  GET /api/market/token-kline
  功能
  查询 token K 线历史数据
  支持 source=binance 与 source=chainlink
  返回统一结构：history[]，每项含 t/close_time/open_price/close_price/high_price/low_price
  Query 参数

  token (string, 必填)：币种，如 BTC、ETH
  source (string, 可选)：binance（默认）或 chainlink
  interval (string, 可选)：与 start_time 二选一情况
  interval 解析规则，当fidelity是1s时，m=分钟，d=天， 当fidelity是其他值时：m=月，d=天，y=年
  start_time (number, 可选)：起始秒级时间戳，与 interval 二选一
  end_time (number, 可选)：结束秒级时间戳，默认当前时间
  fidelity (string, 仅 binance 必填)：
  支持：1s , 1, 5, 60, 240,1440,1m, 5m, 60m, 240m, 1440m
  默认单位是分钟；不带 m 按分钟解析（兼容旧逻辑）
  当 fidelity是 1s 时，interval中的 m=分钟，d=天，当fidelity是其他值时：m=月，d=天，y=年
  返回结构
 */
export type KlineFidelity = '1s' | '60' | '300' | '3600' | '14400' | '86400'; // 秒

export interface TokenKlineIntervalParams {
  token?: string;
  interval: string;
  fidelity: KlineFidelity;
  end_time?: number;
  start_time?: number;
  resolved?: boolean;
}

export interface TokenKlineStartTimeParams {
  fidelity: KlineFidelity;
  start_time: number;
  token?: string;
  end_time?: number;
  resolved?: boolean;
}

export interface KlinePoint {
  close_price: string;
  close_time: number;
  high_price: string;
  low_price: string;
  open_price: string;
  t: number;
}
export interface KlineResponse {
  history: KlinePoint[];
}

export function useTokenKline(params: TokenKlineIntervalParams | TokenKlineStartTimeParams) {
  const { resolved, ...requestParams } = params;
  const searchParams = new URLSearchParams(
    Object.entries(requestParams)
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => [k, `${k === 'fidelity' && v !== '1s' ? `${+v / 60}m` : v}`]),
  );
  return useSWR<KlineResponse>(
    params.token ? `api:/market/token-kline?${searchParams.toString()}` : null,
    {
      refreshInterval: () =>
        resolved || (params.end_time && params.end_time * 1000 < Date.now()) ? 0 : 1000,
    },
  );
}
